import BaseTimeline from "../Base/BaseTimeline";
import { FiArrowLeft } from "react-icons/fi";
import Card from "../Base/Card";
import React, { useState } from "react";
import SuccessModal from "../SuccessModal";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  ChangePasscode,
  ChangePassword,
  GetPasscode,
} from "../../redux/selfService/selfServiceSlice";
import { useAppDispatch } from "../../redux/hooks";
import ErrorViewer from "../ErrorViewer";

const PasscodeManagement = () => {
  const dispatch = useAppDispatch();
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");


  const toggleSuccessModal = () => setShowSuccessModal(!showSuccessModal);

  const validationSchema = Yup.object().shape({
    oldPasscode: Yup.string()
      .required("Please enter old passcode")
      .min(4, "Must be exactly 4 digits")
      .max(4, "Must be exactly 4 digits"),
    newPasscode: Yup.string()
      .required("Please enter new passcode")
      .min(4, "Must be exactly 4 digits")
      .max(4, "Must be exactly 4 digits"),
    confirmNewPasscode: Yup.string()
      .min(4, "Must be exactly 4 digits")
      .max(4, "Must be exactly 4 digits")
      .required("Please retype your passcode.")
      .oneOf([Yup.ref("newPasscode")], "Passcodes must match"),
  });

  const defaultValues = {
    oldPasscode: "",
    newPasscode: "",
    confirmNewPasscode: "",
  };

  const {
    handleSubmit,
    register,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues,
  });

  const onSubmit = (values: any) => {
    dispatch(ChangePasscode(values)).then((res) => {

        setSuccessMessage("Your passcode has been updated successfully.");
      if (
        res?.type === "selfService/ChangePasscode/fulfilled" &&
        res.payload.statusCode === "00"
      ) {
        reset(defaultValues);
      }
    });
  };
  const onGetPassCodeClicked = (values: any) => {
    console.log("Retrieve Passcode button clicked"); // Debugging statement
    dispatch(GetPasscode(values)).then((res) => {
      //console.log("GetPasscode response:", res); // Debugging statement

      if (
        res?.type === "selfService/GetPasscode/fulfilled" &&
        res.payload.statusCode === "00"
      ) {
       //Show PIN dialog
       setSuccessMessage(`Your old passcode is ${res.payload?.responseObject?.passcode}`);
       setShowSuccessModal(true);
      }
      // Handle the response and any potential errors
    });
  };

  return (
    <Card className="w-full">
      <SuccessModal
        showModal={showSuccessModal}
        onClose={toggleSuccessModal}
        note={successMessage}
      />
      <div>
        <div className="mgmt">
         

          <div className="mgmt-head">
            Update Passcode
            <div className="text-xs text-grayscaleLabel">
              Your default passcode is the last four digits of your PIN. You
              should change it to a 4-digit PIN.
            </div>
          </div>

          <div className="form__group">
            <label htmlFor="old-passcode" className="form__label">
              Enter Old Passcode
            </label>
           
            <input
              // placeholder={"0000"}
              type="number"
              id="old-passcode"
              className="form__input scattered"
              maxLength={4}
              {...register("oldPasscode")}
            />
            {errors.oldPasscode && (
              <ErrorViewer message={errors.oldPasscode.message as string} />
            )}
          </div>
          <div className="mgmt-head">
            {/* Get Old Passcode */}
            <div className="text-xs text-grayscaleLabel">
              Your old passcode can be retrieved by tappin on
              <button className="btn-link" onClick={onGetPassCodeClicked}>
                Retrieve Passcode
              </button>
            </div>
          </div>
          <div className="form__group">
            <label htmlFor="verification-code" className="form__label">
              Enter New 4 Digit Passcode
            </label>
            <input
              // placeholder={"0000"}
              type="number"
              id="verification-code"
              className="form__input scattered"
              maxLength={4}
              {...register("newPasscode")}
            />
            {errors.newPasscode && (
              <ErrorViewer message={errors.newPasscode.message as string} />
            )}
          </div>
          <div className="form__group">
            <label htmlFor="verification-code-b" className="form__label">
              Confirm New 4 Digit Passcode
            </label>
            <input
              // placeholder={"0000"}
              type="number"
              id="verification-code-b"
              className="form__input scattered"
              maxLength={4}
              {...register("confirmNewPasscode")}
            />
            {errors.confirmNewPasscode && (
              <ErrorViewer
                message={errors.confirmNewPasscode.message as string}
              />
            )}
          </div>
          <button
            className="btn btn-primary w-full btn-b"
            onClick={handleSubmit(onSubmit)}
          >
            submit
          </button>
        </div>
      </div>
    </Card>
  );
};

export default PasscodeManagement;
